export default __webpack_public_path__ + "static/media/disable_previous_image.adfc2df5.svg";